module.exports = __webpack_public_path__ + "img/shoot_00017.796c480e.png";